export default __webpack_public_path__ + "static/media/find.cb6d959b.svg";